<template>
  <div id="3d_logo"
       class="absolutne w-screen h-screen"
  >
  </div>
</template>

<script>
  import * as THREE from 'three';
  import {ColladaLoader} from 'three/examples/jsm/loaders/ColladaLoader';

  import('../../assets/css/index/3d_logo.css');

  export default {
    name: 'HeroLogo',
    mounted: function () {
      this.scene = new THREE.Scene();

      this.scale = 35;

      this.camera = new THREE.PerspectiveCamera(50, 1, 0.1, 10 * this.scale);

      this.renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
      });

      this.container = document.getElementById('3d_logo');
      this.element = this.renderer.domElement;

      this.container.appendChild(this.element);

      (new ColladaLoader()).load('/assets/models/RW_ruka_V2.dae', model => {
          (new THREE.TextureLoader()).load('/assets/textures/disc.png', texture => {
              this.material = new THREE.PointsMaterial({
                color: 0xFFCF03,
                map: texture,
                size: 2.5,
                sizeAttenuation: false,

                transparent: true,
                depthTest: true,
              });

              model.scene.traverse(obj => {
                if (obj instanceof THREE.Mesh) {
                  let mesh = new THREE.Points(obj.geometry, this.material);

                  mesh.rotateX(3 * Math.PI / 2);

                  this.scene.add(mesh);
                }
              });

              this.scene.scale.set(this.scale, this.scale, this.scale);

              console.log(this.scene);

              this.animate();
            },
            undefined,
            error => console.error(error)
          );
        },
        undefined,
        error => console.error(error)
      );

      this.clock = new THREE.Clock();

      this.r = 5 * this.scale;

      this.phi = 0;
      this.phiVelocity = 0.1;
      //this.psi = 0;
      //this.psiVelocity = 0;

      this.camera.position.y = 0.5 * this.scale;
      this.origin = new THREE.Vector3(0, this.camera.position.y, 0);

      this.onResize = () => {
        this.renderer.setSize(this.container.offsetWidth, this.container.offsetHeight);
        this.element.width = this.container.offsetWidth;
        this.element.height = this.container.offsetHeight;

        this.camera.aspect = this.container.offsetWidth / this.container.offsetHeight;
      };

      this.updateFrame = (delta) => {
        this.phi += this.phiVelocity * delta;

        this.camera.position.z = this.r * Math.cos(this.phi);
        this.camera.position.x = this.r * Math.sin(this.phi);

        this.camera.lookAt(this.origin);
      };

      this.animate = () => {
        this.updateFrame(this.clock.getDelta());

        this.renderer.render(this.scene, this.camera);
        window.requestAnimationFrame(this.animate);
      };

      window.addEventListener('resize', this.onResize, false);
      this.onResize();
    }
  }
</script>
